export const BASE_URL = 'https://sibbrands.ru/api/v1/';
// export const BASE_URL = 'http://127.0.0.1:8000/api/v1/';
